var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "result_item" }, [
    _vm.itemData.label
      ? _c("div", { staticClass: "sticker__blck" }, [
          _c("img", { attrs: { src: "/img/icon/stiker.svg", alt: "" } })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-3 col-md-6 d-flex align-items-stretch" },
        [
          _c("div", { staticClass: "result_logo" }, [
            _c(
              "div",
              { staticClass: "logo" },
              [
                _c("img", { attrs: { src: _vm.itemData.image, alt: "" } }),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    class: "p-light-green min",
                    attrs: { to: { name: "companyPage", params: { id: 3 } } }
                  },
                  [_vm._v("E.ON Energilosningar Aktiebolag abracadabra")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isMobile
              ? _c("div", { staticClass: "right__info" }, [
                  _vm.active2
                    ? _c(
                        "div",
                        {
                          staticClass: "mini-popup",
                          class: { active: _vm.active2 },
                          on: {
                            click: function($event) {
                              _vm.active2 = !_vm.active2
                            }
                          }
                        },
                        [_vm._m(0)]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "cost" }, [
                    _c("p", { staticClass: "p-yellow cost-text" }, [
                      _vm._v("78.01")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "min" }, [
                      _vm._v("öre / kWh incl\n                            "),
                      _c("span", {
                        staticClass: "quest__in_icon",
                        class: { active: _vm.active2 },
                        on: {
                          click: function($event) {
                            _vm.active2 = !_vm.active2
                          }
                        }
                      })
                    ])
                  ])
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-7 col-md-4" }, [
        _c("div", { staticClass: "result_info" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-5  d-flex align-items-stretch" }, [
              _c("div", { staticClass: "left__info" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "main_quest__info" }, [
                  _c("div", { staticClass: "quest__info" }, [
                    _c("p", { staticClass: "p-light-green med" }, [
                      _vm._v(
                        "Fast  price\n                                        "
                      ),
                      _c("span", {
                        staticClass: "quest__in_icon",
                        class: { active: _vm.active1 },
                        on: {
                          click: function($event) {
                            _vm.active1 = !_vm.active1
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.active1
                      ? _c(
                          "div",
                          {
                            staticClass: "mini-popup",
                            class: { active: _vm.active1 },
                            on: {
                              click: function($event) {
                                _vm.active1 = !_vm.active1
                              }
                            }
                          },
                          [_vm._m(2)]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _vm.isMobile && _vm.itemData.typeenergy
                  ? _c("div", { staticClass: "icon_list" }, [
                      _c("div", { staticClass: "icon_list" }, [
                        _c(
                          "div",
                          {
                            staticClass: "icon",
                            class: { active: _vm.active3 }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icon/weather/wind.svg",
                                alt: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.active3 = !_vm.active3
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.active3
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mini-popup",
                                    class: { active: _vm.active3 }
                                  },
                                  [_vm._m(5)]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "icon",
                            class: { active: _vm.active4 }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/img/icon/weather/sun.svg",
                                alt: ""
                              },
                              on: {
                                click: function($event) {
                                  _vm.active4 = !_vm.active4
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.active4
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mini-popup",
                                    class: { active: _vm.active4 }
                                  },
                                  [_vm._m(6)]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMobile && !_vm.itemData.typeenergy
                  ? _c("div", { staticClass: "icon_list" }, [
                      _c(
                        "p",
                        {
                          staticClass: "no_energy",
                          class: { active: _vm.active4 },
                          on: {
                            click: function($event) {
                              _vm.active4 = !_vm.active4
                            }
                          }
                        },
                        [_c("b", [_vm._v("no energy at all")])]
                      ),
                      _vm._v(" "),
                      _vm.active4
                        ? _c(
                            "div",
                            {
                              staticClass: "mini-popup",
                              class: { active: _vm.active4 }
                            },
                            [_vm._m(7)]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-1 d-none d-md-block" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              !_vm.isMobile
                ? _c("div", { staticClass: "right__info" }, [
                    _vm.active2
                      ? _c(
                          "div",
                          {
                            staticClass: "mini-popup",
                            class: { active: _vm.active2 },
                            on: {
                              click: function($event) {
                                _vm.active2 = !_vm.active2
                              }
                            }
                          },
                          [_vm._m(8)]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "cost" }, [
                      _c("p", { staticClass: "p-yellow cost-text" }, [
                        _vm._v("78.01")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "min" }, [
                        _vm._v(
                          "öre / kWh incl\n                                    "
                        ),
                        _c("span", {
                          staticClass: "quest__in_icon",
                          class: { active: _vm.active2 },
                          on: {
                            click: function($event) {
                              _vm.active2 = !_vm.active2
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.itemData.typeenergy
                      ? _c("div", { staticClass: "icon_list" }, [
                          _c(
                            "div",
                            {
                              staticClass: "icon",
                              class: { active: _vm.active3 }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/img/icon/wind.svg", alt: "" },
                                on: {
                                  click: function($event) {
                                    _vm.active3 = !_vm.active3
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.active3
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mini-popup",
                                      class: { active: _vm.active3 }
                                    },
                                    [_vm._m(9)]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "icon",
                              class: { active: _vm.active4 }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/img/icon/sun.svg", alt: "" },
                                on: {
                                  click: function($event) {
                                    _vm.active4 = !_vm.active4
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.active4
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mini-popup",
                                      class: { active: _vm.active4 }
                                    },
                                    [_vm._m(10)]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.itemData.typeenergy
                      ? _c("div", { staticClass: "icon_list" }, [
                          _c("p", {}, [_vm._v("no energy at all")])
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-2 col-md-2 d-flex align-items-stretch" },
        [
          _c("div", { staticClass: "result_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-green btn-full",
                on: {
                  click: function($event) {
                    return _vm.$emit("modalActive")
                  }
                }
              },
              [_vm._v("Further")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-7" }, [
          _c("div", { staticClass: "total" }, [
            _c("p", { staticClass: "p-blue" }, [_vm._v("Total:")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-5" }, [
          _c("div", { staticClass: "total-cost" }, [
            _c("p", { staticClass: "p-yellow" }, [_vm._v("45.90")]),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [_vm._v("öre / kWh incl")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contract__name" }, [
      _c("p", { staticClass: "min relawaySM" }, [_vm._v("Fastpris 6 manader")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Variable price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "min notice" }, [
      _vm._v("Uppsainingstid: "),
      _c("br"),
      _vm._v(" "),
      _c("b", [_vm._v("1 month")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "annual p-light-green med" }, [
      _c("b", [
        _vm._v("Annual cost: "),
        _c("span", { staticClass: "p-dgrey min" }, [_vm._v("5461 kr")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Variable price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Variable price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Variable price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-9" }, [
          _c("div", { staticClass: "title" }, [
            _c("p", { staticClass: "Raleway min p-dgrey" }, [
              _c("b", [_vm._v("Electricity price")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "p-gray2 minimum" }, [
              _vm._v("(incl. electricity certificate, excl. VAT)")
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-3 d-flex align-items-center justify-content-end"
          },
          [
            _c("div", { staticClass: "cost" }, [
              _c("p", { staticClass: "p-dgrey med-max" }, [_vm._v("45.90")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-7" }, [
          _c("div", { staticClass: "total" }, [
            _c("p", { staticClass: "p-blue" }, [_vm._v("Total:")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-5" }, [
          _c("div", { staticClass: "total-cost" }, [
            _c("p", { staticClass: "p-yellow" }, [_vm._v("45.90")]),
            _vm._v(" "),
            _c("p", { staticClass: "min" }, [_vm._v("öre / kWh incl")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Fast price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m_popup__blck" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "Raleway min p-dgrey" }, [
          _c("b", [_vm._v("Variable price")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min p-dgrey" }, [
          _vm._v(
            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }